import { Component } from '@angular/core';
@Component({
  selector: 'app-inr',
  templateUrl: './inr.component.html',
  styleUrls: [ './inr.component.css' ],
})
export class INRComponent {
  constructor() { }
}
